"use client";

import { useState, useEffect } from "react";
import Fab from "@mui/material/Fab";
import Typography from "@mui/material/Typography";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useTheme } from "@mui/material/styles";

export default function BackToTop() {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <Fab
      size="medium"
      onClick={handleClick}
      aria-label="Başa Dön"
      variant="extended"
      sx={{
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: theme.zIndex.modal + 1,
        backgroundColor: "#fff",
        border: `1px solid ${theme.palette.secondary.main}`,
        color: theme.palette.secondary.main,
        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
        // CSS media query for mobile devices
        "@media (max-width: 600px)": {
          "& .MuiFab-label": {
            display: "none",
          },
        },
      }}
    >
      <ArrowUpwardIcon sx={{ color: theme.palette.secondary.main }} />
      <Typography
        variant="button"
        sx={{
          textTransform: "none",
          ml: 1,
          // Hide text on mobile using CSS
          "@media (max-width: 600px)": {
            display: "none",
          },
        }}
      >
        Başa Dön
      </Typography>
    </Fab>
  );
}
